export enum Size {
    LARGE = 'large',
    BIG = 'big',
    DEMI = 'demi',
    MEDIUM = 'medium',
    REGULAR = 'regular',
    SMALL = 'small',
    EXTRA_SMALL = 'extra-small',
    MINIMAL = 'minimal'
  }
  